import Icon from '@package/components/Icon';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import { useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { reviewStateClass } from '../reviewStateClass';
import SubItems from './SubItems';

const NavItem = ({ item, lang, root }) => {
  const { settings } = config;
  const menuRef = useRef();

  const openMenu = () => {
    if (menuRef.current) {
      menuRef.current.classList.remove('close-menu');
    }
  };

  const closeMenuTemporarily = () => {
    if (menuRef?.current) {
      menuRef.current?.classList.add('close-menu-temporary');
      setTimeout(() => {
        menuRef.current?.classList.remove('close-menu-temporary');
      }, 300); // Tempo da animação em milissegundos
    }
  };

  useEffect(() => {
    window.addEventListener('click', closeMenuTemporarily);
    openMenu(); // Ensure the menu can open again after navigation
    return () => {
      window.removeEventListener('click', closeMenuTemporarily);
    };
  });

  if (item.items.length > 0) {
    return (
      <div className="parent" ref={menuRef}>
        <NavLink
          to={item.url === '' ? '/' : item.url}
          className={reviewStateClass(item.review_state, 'item link')}
          activeClassName="selected"
          onClick={(e) => {
            // closeMenuTemporarily();
          }}
        >
          {item.title}
          <Icon name="keyboard_arrow_down" bold />
        </NavLink>
        <SubItems item={item} lang={lang} onClose={closeMenuTemporarily} root />
      </div>
    );
  }

  // The item.url in the root is ''
  // TODO: make more consistent it everywhere (eg. reducers to return '/' instead of '')
  if (isInternalURL(item.url) || item.url === '') {
    return (
      <div className="parent">
        <NavLink
          to={item.url === '' ? '/' : item.url}
          key={item.url}
          className={reviewStateClass(item.review_state, 'item link')}
          activeClassName="selected"
          exact={
            settings.isMultilingual
              ? item.url === `/${toBackendLang(lang)}`
              : item.url === ''
          }
        >
          {item.title}
        </NavLink>
      </div>
    );
  }

  return (
    <div className="parent">
      <a
        href={item.url}
        key={item.url}
        className={reviewStateClass(item.review_state, 'item link')}
        rel="noopener noreferrer"
        target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
        onClick={closeMenuTemporarily}
      >
        {item.title}
      </a>
    </div>
  );
};

export default NavItem;
